module.exports = function() {
  return new Worker("/" + "svelte-transpiler.af511f3a.worker.js");
};